export const GET_HAPPINESS_TIPS_CATEGORIES = "GET_HAPPINESS_TIPS_CATEGORIES";
export const GET_STATE_LOADING = "GET_STATE_LOADING";
